<template>
  <div>
    <NewQuizPageRoundsItem
      v-for="round in quiz.rounds"
      v-bind:key="round.id"
      v-bind:round="round"
      @validity="checkValidity"
      @delete="deleteRound"
    />
    <b-button variant="success" block @click="addRound"
      >Add another round</b-button
    >
  </div>
</template>

<script>
import NewQuizPageRoundsItem from "@/components/host/NewQuizPageRoundsItem";

export default {
  name: "NewQuizPageRounds",
  props: ["quiz", "validity"],
  model: {
    prop: "validity",
    event: "validity"
  },
  components: { NewQuizPageRoundsItem },
  created() {
    if (this.quiz.rounds && this.quiz.rounds.length == 0) {
      this.addRound("Pictures");
      this.addRound("General Knowledge");
      this.addRound("Blockbuster");
      this.addRound("Anagrams");
      this.addRound("Connection Round");
    }

    this.checkValidity();
  },
  methods: {
    getEmptyRound(title) {
      return {
        name: typeof title === "string" ? title : "New round",
        score_max: 10,
        allow_half_points: 0,
        valid: true
      };
    },
    addRound(title) {
      var round = this.getEmptyRound(title);
      this.quiz.rounds.push(round);
    },
    checkValidity() {
      var valid = this.quiz.rounds.length > 0;
      this.quiz.rounds.forEach(round => {
        valid = valid & round.valid;
      });

      this.$emit("validity", valid);
    },
    deleteRound(round) {
      const index = this.quiz.rounds.indexOf(round);
      if (index > -1) {
        this.quiz.rounds.splice(index, 1);
      }
      this.checkValidity();
    }
  }
};
</script>
